'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _draftJs = require('draft-js');

var _util = require('./util');

var _EmojiButton = require('./EmojiButton');

var _EmojiButton2 = _interopRequireDefault(_EmojiButton);

var _EmojiIcon = require('./EmojiIcon');

var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);

var _EmojiRaw = require('./EmojiRaw');

var _EmojiRaw2 = _interopRequireDefault(_EmojiRaw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function noop() {};

var emojiRex = /\[([\u4e00-\u9fa5])+\]/g;

function findWithRegex(regex, contentBlock, callback) {
  var text = contentBlock.getText();
  var matchArr = void 0,
      start = void 0;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}

function findEntities(entityType) {
  return function findEntitiesFunc(contentBlock, callback) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return entityKey !== null && _draftJs.Entity.get(entityKey).getType() === entityType;
    }, callback);
  };
}

var Emoji = {
  constructor: function constructor() {
    var _this = this;

    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var callbacks = {
      getEditorState: noop,
      setEditorState: noop,
      focus: noop
    };
    function pickEmoji(emoji) {
      var editorState = callbacks.getEditorState();
      callbacks.setEditorState((0, _util.insertEntity)(editorState, 'emoji', { emoji: emoji, "export": _util.exportEntity }), true);
    }
    return {
      name: 'emoji',
      callbacks: callbacks,
      decorators: [{
        strategy: findEntities('emoji'),
        component: _EmojiIcon2["default"]
      }, {
        strategy: function strategy(contentBlock, callback) {
          return findWithRegex(emojiRex, contentBlock, callback);
        },
        component: function component(props) {
          return _react2["default"].createElement(_EmojiRaw2["default"], _extends({ callbacks: callbacks }, props));
        }
      }],
      component: function component(props) {
        return _react2["default"].createElement(_EmojiButton2["default"], { onChange: pickEmoji.bind(_this) });
      }
    };
  },

  config: {}
};

exports["default"] = Emoji;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-emoji@0.2.9@rc-editor-plugin-emoji/lib/EditorPluginEmoji.js
// module id = 215
// module chunks = 0 1 2